import { render, staticRenderFns } from "./ListStudent.vue?vue&type=template&id=3022af1e"
import script from "./ListStudent.vue?vue&type=script&lang=js"
export * from "./ListStudent.vue?vue&type=script&lang=js"
import style0 from "./ListStudent.vue?vue&type=style&index=0&id=3022af1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports